import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import './Checkbox.scss';

export const ThreeppCheckbox = props => {
  const { onChange, checked, value, label, disabled, indeterminate, color = 'primary' } = props;
  const style = {
    display: 'inherit'
  };
  const checkbox = (
    <Checkbox
      className={`threepp-checkbox ${checked ? 'checked' : ''}`}
      checked={checked}
      onChange={onChange}
      value={value}
      disabled={disabled}
      indeterminate={indeterminate}
      color={color}
    />
  );
  return (
    <FormControlLabel
      control={checkbox}
      label={label}
      classes={{
        root: 'threepp-checkbox-wrapper',
        label: 'threepp-checkbox-label'
      }}
      style={style}
    />
  );
};

export default ThreeppCheckbox;
